import LoadingSkeleton from 'common-components/LoadingSkeleton'

import * as Styled from './styled'

interface IProps {
  itemsCount?: number
}
export const SoundsListSkeleton: React.FC<IProps> = ({ itemsCount = 10 }) => {
  const items = new Array(itemsCount).fill(null)

  return (
    <Styled.SoundsListSkeletonContainer>
      {items.map((item, index) => (
        // TODO: @gev-davtyan-rf check if we can have something better than index
        // eslint-disable-next-line react/no-array-index-key
        <Styled.SoundsListItemWrapper key={item?.id ?? index}>
          <LoadingSkeleton />
        </Styled.SoundsListItemWrapper>
      ))}
    </Styled.SoundsListSkeletonContainer>
  )
}
